export const downloadBlobFile = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export const fetchCallSheetPdfBlob = async ({ apiBase, projectId, sheetId, token, synopsisLang = 'english' }) => {
  const response = await fetch(
    `${apiBase}/api/projects/${projectId}/call-sheets/${sheetId}/export/pdf?synopsis_lang=${encodeURIComponent(synopsisLang)}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  if (!response.ok) {
    let detail = 'PDF generation failed';
    try {
      const errorJson = await response.json();
      detail = errorJson?.detail || detail;
    } catch {
      const text = await response.text();
      if (text) detail = text;
    }
    throw new Error(detail);
  }

  return response.blob();
};

export const downloadCallSheetPdf = async ({ apiBase, projectId, sheetId, token, synopsisLang = 'english', filename }) => {
  const blob = await fetchCallSheetPdfBlob({ apiBase, projectId, sheetId, token, synopsisLang });
  downloadBlobFile(blob, filename);
};